import { ClientPurchaseOrderFolder } from "@redotech/redo-model/views/folders";
import { ClientPurchaseOrdersView } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getPurchaseOrderViewsAndFolders = {
  name: "getPurchaseOrderViewsAndFolders" as const,
  input: z.null(),
  output: z.object({
    folders: z.array(ClientPurchaseOrderFolder),
    views: z.array(ClientPurchaseOrdersView),
  }),
};
